import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Link from "../Link";
import SignUpButton from "../SignUpButton";
import MemberBenefitTable, {
  getCriteriaHeading,
  getZMTZiplockRate,
} from "../MemberBenefitTable";
import { isTranslationEmpty } from "../../utils";

const AvailableAssetsTable = ({ productName, content, coinInterestRates }) => {
  const { t } = useTranslation();
  const ziplockApy = useMemo(
    () => getZMTZiplockRate(coinInterestRates),
    [coinInterestRates]
  );

  const getRateText = (rate) => [
    {
      name: (
        <>
          {rate}% <span>APY</span>
        </>
      ),
    },
  ];

  const headings = [
    getCriteriaHeading(
      t("earn.availableAssets.criteria"),
      t("earn.availableAssets.buyAndLock"),
      <strong>
        {t("earn.availableAssets.getZiplockAPY", { apy: ziplockApy })}
      </strong>
    ),
  ];

  const benefits = coinInterestRates.nodes.map(
    ({
      acfCoinInterestRates: {
        cirCoinIconTable,
        cirCoinCode,
        zipupInterateRateV2,
      },
    }) => {
      return {
        title: (
          <>
            <img
              src={cirCoinIconTable.localFile.publicURL}
              alt=""
              className="img-fluid mr-2 mr-md-3 ml-2 ml-md-4 ml-lg-5"
              width={25}
              height={25}
            />{" "}
            <div className="d-flex flex-column text-left">
              <span>{cirCoinCode}</span>
            </div>
          </>
        ),
        vip: getRateText(zipupInterateRateV2.vip0.rate),
        vip1: getRateText(zipupInterateRateV2.vip1.rate),
        vip2: getRateText(zipupInterateRateV2.vip2.rate),
        vip3: getRateText(zipupInterateRateV2.vip3.rate),
        vip4: getRateText(zipupInterateRateV2.vip4.rate),
      };
    }
  );

  return (
    <>
      <div id="available-assets">
        <div className="container">
          <div className="text-center mb-5">
            <h2
              className={`${content.edges[0].node.acfPartials.pCssClasses}`}
              dangerouslySetInnerHTML={{
                __html: content.edges[0].node.acfPartials.pHeading,
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: content.edges[0].node.acfPartials.pContent,
              }}
            />
          </div>

          <MemberBenefitTable
            className="available-assets-table"
            tableTitle={
              <>
                {t("earn.availableAssets.coin")} \{" "}
                <Link className="ml-1" to={`/zmt/#welcome-to-zipcrew`}>
                  {t("earn.availableAssets.memberLevel")}
                </Link>
              </>
            }
            benefits={headings.concat(benefits)}
            footer={{
              link: !isTranslationEmpty(
                t,
                `${productName}.linkTermsAndConditions`
              ) && (
                <Link to={t(`${productName}.linkTermsAndConditions`)}>
                  {t(`${productName}.termsAndConditions`)}
                </Link>
              ),
              button: (
                <SignUpButton target="_blank">
                  {t("earn.availableAssets.btnOpenAccount")} &#8594;
                </SignUpButton>
              ),
            }}
          />
        </div>
      </div>
    </>
  );
};

AvailableAssetsTable.propTypes = {
  productName: PropTypes.oneOf(["earn"]).isRequired,
  content: PropTypes.object.isRequired,
  coinInterestRates: PropTypes.object.isRequired,
};
export default AvailableAssetsTable;
